import defaultGlobalStyle from "./defaultGlobalStyle";
import classicThemeStyle from "./classicThemeStyle";
import lightThemeStyle from "./lightThemeStyle";
import darkThemeStyle from "./darkThemeStyle";

const GlobalStyle = ({ theme }) => {
  switch (theme) {
    case "CLASSIC":
      defaultGlobalStyle();
      classicThemeStyle();
      break;
    case "DARK":
      defaultGlobalStyle();
      darkThemeStyle();
      break;
    case "LIGHT":
      defaultGlobalStyle();
      lightThemeStyle();
      break;
    default:
      break;
  }
  return null;
};

export default GlobalStyle;
